import React from 'react'
import { useAppDispatch } from '../hooks/reduxToolkit'
import { useAsyncAction } from '../hooks/useAsyncAction'
import { useClient, useSession } from '../providers/supabase'
import { persistor } from '../reduxToolkit/store';
import { signOutToNative } from '../../lib/nativeAuth';

export function SignOutButton({ className, children }: React.PropsWithChildren<{ className?: string }>) {
  const session = useSession()
  const client = useClient()
  const dispatch = useAppDispatch()

  const [signOutStatus, doSignOut] = useAsyncAction(async (evt: React.MouseEvent) => {
    evt.preventDefault();

    // delete laravel_session cookie
    document.cookie = 'laravel_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    const resp = await client.auth.signOut()
    if (resp.error) { throw resp.error }

    // Tell the native shell (Phase 3 of docs/plans/expo-owned-signin.md). The
    // signOut above is a *global* revoke, so the refresh token native holds is
    // now dead too — without this, native would keep a webview mounted on a
    // session that no longer exists instead of returning to its sign-in
    // screen. Sent after the revoke succeeded so a failed sign-out doesn't
    // drop native out from under a still-signed-in webview. No-ops in a
    // browser and on native builds that predate the handoff.
    signOutToNative()

    await persistor.purge()
    setTimeout(() => {
      // Clear out any hash params
      const url = new URL(window.location.href)
      url.pathname = '/'
      url.hash = ''
      window.history.pushState({}, '', url)
      window.location.reload()
    }, 100)
  }, [client, dispatch])

  if (!session) {
    return null
  }

  if (signOutStatus.error) {
    throw signOutStatus.error
  }

  return <a className={`${className || 'btn btn-link'}`} href="/"
      onClick={doSignOut}>
    {children}
  </a>

}
